/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';

export const CheckIcon = (): React.Element<'svg'> => (
  <svg className="checkmark" width="34" height="34" data-bind="attr:{width:size,height:size}"
    viewBox="0 0 70 70"
  >
    <path
      d="m31.5,46.5l15.3,-23.2"
      style={{
        strokeDasharray: 27.7908,
        strokeDashoffset: 0
      }}
    />
    <path
      d="m31.5,46.5l-8.5,-7.1"
      style={{
        strokeDasharray: 11.0752,
        strokeDashoffset: 0
      }}
    />
  </svg>
);

export const CrossIcon = (): React.Element<'svg'> => (
  <svg className="cross" width="34" height="34" data-bind="attr:{width:size,height:size}"
    viewBox="0 0 70 70"
  >
    <path
      d="m35,35l-9.3,-9.3"
      style={{
        strokeDasharray: 13.1522,
        strokeDashoffset: 13.1522
      }}
    />
    <path
      d="m35,35l9.3,9.3"
      style={{
        strokeDasharray: 13.1522,
        strokeDashoffset: 13.1522
      }}
    />
    <path
      d="m35,35l-9.3,9.3"
      style={{
        strokeDasharray: 13.1522,
        strokeDashoffset: 13.1522
      }}
    />
    <path
      d="m35,35l9.3,-9.3"
      style={{
        strokeDasharray: 13.1522,
        strokeDashoffset: 13.1522
      }}
    />
  </svg>
);

export const DownloadIcon = ({ ...attr }): React.Element<'svg'> => (
<svg {...attr} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
  x="0px" y="0px"
  viewBox="0 0 512 512" style={{ fill: 'white', enableBackground: 'new 0 0 512 512' }} xmlSpace="preserve"
>
<g>
	<g>
		<path d="M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64
			c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472
			c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z"
		/>
	</g>
</g>
<g>
	<g>
		<path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z"/>
	</g>
</g>
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
<g />
</svg>
);
